import { render } from "./TaskInfo.vue?vue&type=template&id=e99f2c0c&scoped=true&ts=true"
import script from "./TaskInfo.vue?vue&type=script&lang=ts"
export * from "./TaskInfo.vue?vue&type=script&lang=ts"

import "./TaskInfo.vue?vue&type=style&index=0&id=e99f2c0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99f2c0c"]])

export default __exports__